<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode"
    [characterCount]="characterCount"
    [focused]="focused()">
    @if (isEditMode) {
        <kendo-textbox
            [type]="password ? 'password' : 'text'"
            [title]="title | translate"
            [placeholder]="placeholder | translate"
            [maxlength]="maxLength"
            [minlength]="minLength"
            [disabled]="isDisabled"
            [ngClass]="generateInputStyle()"
            [(ngModel)]="value"
            (valueChange)="onValueChange($event)"
            (inputFocus)="onFocusIn()"
            (inputBlur)="onFocusOut()"
            (keypress)="onKeyPress($event)">
            <ng-template kendoTextBoxSuffixTemplate>
                <ng-content select=".textbox-suffix"></ng-content>
            </ng-template>
        </kendo-textbox>
        <app-input-error [error]="error()?.[0]" />
    } @else {
        <div class="w-full truncate pt-1.5 pb-1">
            <span kendoTooltip [title]="value()">
                {{ value() }}
            </span>
        </div>
    }
</app-input-label>
